import {
  GatewayCategoryPageRequestDto,
  GatewayCategoryPageResponseDto,
} from '../models/gateway-category';
import { FIVE_MINUTE_POST_CACHE_CONFIG } from './cache-config';
import { gatewayRequests } from './http-client';

const GatewayCategory = {
  getCategoriesPage: (request: GatewayCategoryPageRequestDto) =>
    gatewayRequests.post<GatewayCategoryPageResponseDto>(
      '/api/category-service/category/page',
      request,
      FIVE_MINUTE_POST_CACHE_CONFIG
    ),
};

export default GatewayCategory;
